import React, {useEffect, useState} from 'react';
import {ToastContainer} from 'react-toastify';
import AppLoader from '../HelperClasses/AppLoaderClasses/AppLoader';
import HeaderView from '../Settings/HeaderView';
import {loadCategoriesApi} from '../Actions/getCategories';
import AccountForm from './AccountForm';
import {loadAttributesByCategory} from '../Actions/getAttributesByCategory';
import ToastPopup from '../HelperClasses/AppLoaderClasses/ToastPopup';
import {create_store_click} from '../Actions/createAccount';
import {getAllUsers} from '../Actions/getUsers';
import {checkAccountForm} from './actions/checkAccountForm';

const CreateAccount = ({closeModal, load_accounts}) => {
  const [form_state, setFormState] = useState({
    name: '',
    description: '',
    image_path: '',
    category: '',
    user_id: '',
    type: 'accounts',
  });
  const [categories, setCategories] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [attributeData, setAttributeData] = useState(null);
  const [users, setUsers] = useState(null);

  // load category
  useEffect(() => {
    loadCategoriesApi({type: 'accounts'}).then(res => {
      setCategories(res);
    });
    getAllUsers({}).then(res => {
      setUsers(res);
    });
  }, []);

  useEffect(() => {
    if (form_state?.category) {
      setIsLoading(true);
      setAttributes([]);
      setAttributeData(null);
      loadAttributesByCategory({
        type: 'accounts',
        category_id: form_state?.category,
      }).then(res => {
        setAttributes(res);
        setIsLoading(false);
      });
    }
  }, [form_state?.category]);

  // onUpdateForm
  const onUpdateForm = ({key, value}) => {
    setFormState({
      ...form_state,
      [key]: value,
    });
  };
  return (
    <div className="  w-full h-full py-4">
      <HeaderView
        title={'Create New Account'}
        saveBtnTitle={'Save'}
        saveBtn={() => {
          if (isLoading) {
            ToastPopup({type: 'warning', message: 'Please wait...'});
          } else {
            const checkup = checkAccountForm({
              form_data: form_state,
              attributes,
              attributeData,
            });

            if (checkup) {
              create_store_click({
                form_state,
                attributes,
                attributeData,
                setIsLoading,
                closeModal,
                load_accounts,
              });
            }
          }
        }}
        backBtn={() => closeModal()}
      />
      {/* Cretae*/}
      <AccountForm
        form_state={form_state}
        onUpdateForm={onUpdateForm}
        categories={categories}
        attributes={attributes}
        attributeData={attributeData}
        setAttributeData={setAttributeData}
        users={users}
      />

      <ToastContainer />
      <AppLoader enable={!isLoading} />
    </div>
  );
};

export default CreateAccount;
